import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M15.218 13.044a7.61 7.61 0 0 1 5.979-7.432 7.609 7.609 0 1 0 0 14.864 7.61 7.61 0 0 1-5.979-7.432ZM25 5.979l.54 1.66h1.746l-1.412 1.027.54 1.66L25 9.3l-1.413 1.026.54-1.66-1.413-1.027h1.746L25 5.98Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m20.765 9.24.54 1.66h1.745l-1.412 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66ZM29.236 9.24l.54 1.66h1.746l-1.412 1.026.54 1.661-1.413-1.026-1.413 1.026.54-1.66L26.95 10.9h1.746l.54-1.66ZM27.607 14.13l.54 1.662h1.746l-1.413 1.026.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661ZM22.397 14.13l.54 1.662h1.745l-1.412 1.026.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661Z"
}));
FlagSG.displayName = 'FlagSG';
export default withFlagWrapper(FlagSG);
//# sourceMappingURL=index.js.map